import { type PropsWithChildren, Suspense } from 'react';

import LoadingSpinnerCenter from '~/components/LoadingSpinnerCenter';
import RecommendSearchLayout from '~/layouts/RecommendSearchLayout';

export function SearchLayout({ children }: PropsWithChildren) {
  return (
    <RecommendSearchLayout>
      <Suspense fallback={<LoadingSpinnerCenter />}>{children}</Suspense>
    </RecommendSearchLayout>
  );
}
